import { useMemo } from 'react';

import { useGetPublicBoardClip } from '~/swr-hooks/shortUrl/useGetPublicBoardClip';
import { type ClipSeoData, convertClipToSeoData } from '~/swr-hooks/shortUrl/utils';

export const useActiveClipSeoData = ({
  clipId,
  shortId,
  initialClipData,
}: {
  clipId?: string;
  shortId?: string;
  initialClipData?: ClipSeoData | null;
}) => {
  const { data: fetchedClip } = useGetPublicBoardClip({ clipId, shortId });

  return useMemo(() => {
    if (!fetchedClip) {
      return initialClipData ?? null;
    }

    return convertClipToSeoData(fetchedClip);
  }, [fetchedClip, initialClipData]);
};
